var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatabaseSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0008 11.6927V4.99932M21.0008 4.99932C21.0008 6.65627 16.9712 7.99949 12.0004 7.99949C7.02961 7.99949 3 6.65627 3 4.99932M21.0008 4.99932C21.0008 3.34237 16.9712 1.99915 12.0004 1.99915C7.02961 1.99915 3 3.34237 3 4.99932M3 4.99932V19.0001C2.99982 19.402 3.24186 19.7998 3.71176 20.1699C4.18166 20.54 4.86984 20.8749 5.73544 21.1546C6.60105 21.4343 7.62644 21.6533 8.75074 21.7984C9.87504 21.9435 11.0753 22.0118 12.2804 21.9993M22.0008 22.0003L20.1257 20.1252M3 11.9997C3.00023 12.7779 3.90747 13.5256 5.53022 14.085C7.15297 14.6444 9.36426 14.9717 11.6974 14.9979M21.0008 18.0001C21.0008 19.657 19.6576 21.0002 18.0006 21.0002C16.3437 21.0002 15.0005 19.657 15.0005 18.0001C15.0005 16.3431 16.3437 14.9999 18.0006 14.9999C19.6576 14.9999 21.0008 16.3431 21.0008 18.0001Z",
    stroke: "#005BF0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabaseSearchIcon);
export default __webpack_public_path__ + "static/media/DatabaseSearchIcon.789c4bc77e6d52e325d1446d4ceda267.svg";
export { ForwardRef as ReactComponent };